// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__3UStT","open":"styles_open__5Tqdh","content":"styles_content__sIqKJ"};